<template>
  <div>
    <p v-if="uiLock">
      {{ $t('data_import.next_import_possible') }} {{ minutes }}:{{ seconds }}
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      uiLock: false,
      uiLockTimeLeft: 0,
      uiLockIntervalId: null,
      uiLockTotalDuration: 600000,
    }
  },
  computed: {
    minutes() {
      const minutes = Math.floor(this.uiLockTimeLeft / 60000)
      return String(minutes).padStart(2, '0')
    },
    seconds() {
      const seconds = Math.floor((this.uiLockTimeLeft % 60000) / 1000)
      return String(seconds).padStart(2, '0')
    },
  },
  methods: {
    lockImportOnUiSide() {
      this.uiLock = true
      this.uiLockTimeLeft = this.uiLockTotalDuration

      this.$emit('ui-lock-changed', this.uiLock)

      this.uiLockIntervalId = setInterval(() => {
        if (this.uiLockTimeLeft > 0) {
          this.uiLockTimeLeft -= 1000
        } else {
          this.releaseUiLock()
        }
      }, 1000)

      setTimeout(() => {
        this.releaseUiLock()
      }, this.uiLockTotalDuration)
    },
    releaseUiLock() {
      this.uiLock = false
      clearInterval(this.uiLockIntervalId)
      this.uiLockTimeLeft = 0

      this.$emit('ui-lock-changed', this.uiLock)
    },
  },
}
</script>
